"use client";

import { c as _c } from "react/compiler-runtime";
import type { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import DistributionPlanToolPlansTableItem from "./DistributionPlanToolPlansTableItem";
export default function DistributionPlanToolPlansTable(t0) {
  const $ = _c(8);
  const {
    plans,
    onDeleted
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <thead className="tw-bg-iron-800/60"><tr><th scope="col" className="tw-py-3 tw-px-3 tw-whitespace-nowrap tw-text-left tw-text-[0.6875rem] tw-leading-[1.125rem] tw-font-medium tw-text-iron-400 tw-uppercase tw-tracking-[0.25px] sm:tw-pl-6">Name</th><th scope="col" className="tw-px-3 tw-py-3 tw-whitespace-nowrap tw-text-left tw-text-[0.6875rem] tw-leading-[1.125rem] tw-font-medium tw-text-iron-400 tw-uppercase tw-tracking-[0.25px]">Description</th><th scope="col" className="tw-px-3 tw-py-3 tw-whitespace-nowrap tw-text-left tw-text-[0.6875rem] tw-leading-[1.125rem] tw-font-medium tw-text-iron-400 tw-uppercase tw-tracking-[0.25px]">Date</th><th scope="col" className="tw-sr-only tw-px-3 tw-py-3 tw-whitespace-nowrap tw-text-left tw-text-[0.6875rem] tw-leading-[1.125rem] tw-font-medium tw-text-iron-400 tw-uppercase tw-tracking-[0.25px] sm:tw-pr-6">Delete</th></tr></thead>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onDeleted || $[2] !== plans) {
    let t3;
    if ($[4] !== onDeleted) {
      t3 = plan => <DistributionPlanToolPlansTableItem plan={plan} key={plan.id} onDeleted={onDeleted} />;
      $[4] = onDeleted;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = plans.map(t3);
    $[1] = onDeleted;
    $[2] = plans;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div><div className="tw-mt-8 tw-flow-root"><div className="-tw-mx-4 tw-overflow-x-auto sm:-tw-mx-6 lg:-tw-mx-8"><div className="tw-inline-block tw-min-w-full tw-py-2 tw-align-middle sm:tw-px-6 lg:tw-px-8"><div className="tw-overflow-hidden tw-shadow tw-ring-1 tw-ring-white/10 tw-rounded-lg"><table className="tw-min-w-full tw-divide-y tw-divide-iron-700/60">{t1}<tbody className="tw-bg-iron-900 tw-divide-y tw-divide-iron-700/40">{t2}</tbody></table></div></div></div></div></div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}